import axiosInstance from 'api/axiosInstance';
import { ParkingLocation } from 'containers/pages/CANpark/types/parkingLocation';
import { apiRawToParkingLocation } from 'containers/pages/CANparkAdmin/utils/apiRawToParkingLocation';

export const getParkingLocationsByCustomerId = async (
	customerId: string,
): Promise<ParkingLocation[]> => {
	const API_URL = `/api2.0/parkingLocations/getParkingLocations?companyId=${customerId}`;
	try {
		const response = await axiosInstance.get(API_URL);
		// Convert backend format to frontend format
		const formattedData: ParkingLocation[] = response.data.map(
			(location: any) => apiRawToParkingLocation(location),
		);
		return formattedData;
	} catch (error) {
		console.error('Error fetching parking lots:', error);
		throw error;
	}
};
